import SiteHeader from "./components/site-header";
import PartnersSlider from "./components/partners-slider";
import HandheldMenu from "./components/handheld-menu";
// import CookiesConsent from "./components/cookies-consent";
import DeviceManager from "./utils/device-manager";
import HeaderPartnersSlider from "./components/header-partner-slider";
import SocialShare from "./components/social-share";
import Infinite from "./components/infinite";
import AccordionGroup from "./components/accordions-group";
import Accordion from "./components/accordion-faq";
import PopUp from "./components/pop-up";
import Autocomplete from "./components/autocomplete";
import Cart from "./components/cart";
import Tabs from "./components/tabs";
import ApplicationActions from "./components/application-actions";
import UploadBlock from "./components/upload-block";
import initScrollToAnchor from "./components/scroll-to-anchor";
import formValidation from "./components/form-validation";
import ContactPopup from "./components/call-us-popup";

(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}
        
        DeviceManager.calculateScrollbarWidth();

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Partners slider component
		const $partnersSliders = $(".partners-slider");
		if ($partnersSliders.length) {
			$partnersSliders.each(function (index, el) {
				const partnerSlider = new PartnersSlider($(el));
			});
		}

		// Home header partners slider component
		const $homePartnersSliders = $(".homepage-header__partners-slider");
		if ($homePartnersSliders.length) {
			$homePartnersSliders.each(function (index, el) {
				const homePartnerSlider = new HeaderPartnersSlider($(el));
			});
		}

		// Cookie consent
		/*if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}*/
		// Social share popup
		const socialShare = document.querySelector('.share-button-wrapper');
		if (socialShare) {
			const socialSharesecond = new SocialShare(socialShare);
		};

		// Slider partenaires
		const $front_page_slider_partners = $(".partner-logo_section");
		if ($front_page_slider_partners.length) {
			$front_page_slider_partners.each(function (index, el) {
				const frontPageSliderPartners = new PartnersSlider($(el));
			});
		}

		/**
		 * Questions lors de la clôture d'un recrutement
		 */
		if($('.page-template-recruitment-close').length) {
			$('[data-target]').on('click', function(event) {
				var target = $(this).data('target');
				var variant = $(this).data('variant');

				// On masque d'office les questions suivantes des fois que l'utilisateur
				// revienne sur ses réponses…
				var li = $(this).parents('li');

				li.nextAll().hide();
				li.nextAll().find('.answer').hide();

				$('#' + target).slideDown(function() {
					if(variant.length) {
						$('#' + target).find('.answer-' + variant).fadeIn(150);
					}
				});				
			});
		}

        // Application statuses buttons
        const $applicationStatusButtons = $('.application__actions input[name="status"]');
        if($applicationStatusButtons.length) {
            const applicationsActions = new ApplicationActions($applicationStatusButtons);
        }

        // Upload blocks
        const $uploadBlocks = $('.upload-block');
        if($uploadBlocks.length) {
            $uploadBlocks.each(function(index, el) {
                const uploadBlock = new UploadBlock(el);
            });
        }

        // Accordions
        const $accordionsGroup = $('.accordions-group');
        if($accordionsGroup.length) {
            $accordionsGroup.each(function(index, el) {
                const accordionsGroup = new AccordionGroup(el);
            });
        }

        // L'initialisation de `ScrollToAnchor` doit se faire après la création des `AccordionGroup`
        initScrollToAnchor();

		/**
		 * Gestion des commentaires sur la page d'une candidature
		 */
		if($('.page-template-application').length) {
			// Suppression
			$('.comment-delete').on('click', function() {
				const commentId = $(this).data('id');
				const comment = $(this).parents('.comment');

				$.post(ajaxurl, {action: 'deleteApplicationComment', id: commentId}, function(data) {
					if(data.status) {
						comment.fadeOut();
					}
				});
			});

			// Édition
			$('.comment-edit').on('click', function() {
				var comment = $(this).parents('.comment').find('.comment-text');

				if(comment.get(0).tagName == 'TEXTAREA') { // Cas de la sauvegarde
					const commentId = $(this).data('id');
					const btn = $(this);

					btn.text('Sauvegarde…');

					$.post(ajaxurl, {action: 'editApplicationComment', id: commentId, comment: comment.val()}, function(data) {
						if(data.status) {
							comment.replaceWith(
								$('<p>')
									.addClass('comment-text')
									.html(data.comment.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '<br>'))
							);
			
							btn.text('Modifier');
						}
						else {
							btn.text('Sauvegarder');
						}
					});					
				}
				else { // Cas du remplacement du <p> par <textarea>
					comment.replaceWith(
						$('<textarea>')
							.addClass('field comment-text')
							.val(comment.text().replace('<br>', '\n'))
					);
	
					$(this).text('Sauvegarder');
				}
			});
		}

		/**
		 * Bouton « Plus de suggestions »
		 */
		if($('.page-template-results-catalogue').length) {
			$('.free-search_more-results .catalog-offer').hide();

			$('#more-offers-button').on('click', function() {
				$('.free-search_more-results .catalog-offer').slideDown('slow', function() {
					$('.free-search_more-results-container').hide();
				});
			});
		}

        /**
         * Gestion du clic sur les résultats de recherche du catalogue
         */
        const $catalogOffers = $('.catalog-offer');
        
        if($catalogOffers.length) {
            $catalogOffers.on('click', function(e) {
                const $target = $(e.target);
                   
                if(!$target.hasClass('see-more')) {
                    const $offerDetailsButton = $(this).find('.button.see-more');
                    
                    if($offerDetailsButton.length) {
                        $offerDetailsButton.click();
                    }
                }
            });
        }
	});
})(jQuery);